"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    dataGridCellClassNames: function() {
        return dataGridCellClassNames;
    },
    useDataGridCellStyles_unstable: function() {
        return useDataGridCellStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _useTableCellStylesstyles = require("../TableCell/useTableCellStyles.styles");
const dataGridCellClassNames = {
    root: 'fui-DataGridCell'
};
const useDataGridCellStyles_unstable = (state)=>{
    'use no memo';
    (0, _useTableCellStylesstyles.useTableCellStyles_unstable)(state);
    state.root.className = (0, _react.mergeClasses)(dataGridCellClassNames.root, state.root.className);
    return state;
}; //# sourceMappingURL=useDataGridCellStyles.styles.js.map
